// extracted by mini-css-extract-plugin
export var wrapper = "LinkGrid-module--wrapper--2Hroq";